<template>
  <div style="background-color: gray">
    <van-sticky>
      <div style="background-color: white;">
        <van-search
          style="margin: 0 4px 0 0"
          :show-action="addable"
          v-model="filter.searchText"
          placeholder="商品名称、编号"
          @search="onSearch">
          <template #left>
            <el-button type="text" style="color: #4A95F0; font-size: 14px" @click="goBack">&lt; 返回</el-button>
            <span style="margin-right: 10px; color: deepskyblue; font-weight: 500">内领管理</span>
          </template>
          <template #action>
            <van-button round @click="add" size="small">新增内领+</van-button>
          </template>
        </van-search>
        <div style="border-top: solid 1px lightgray; height: 0"></div>
        <div style="display: flex; justify-content: space-around; align-items: center; padding: 8px 0">
          <span style="color: deepskyblue; font-weight: 500">内领单据列表</span>
          <van-button style="color: deepskyblue; font-weight: 500; width: 100px" @click="onMoreFilter" size="small">
            筛选
          </van-button>
        </div>
        <div style="border-top: solid 1px gray; height: 0"></div>
      </div>
    </van-sticky>
    <div style="padding-bottom: 20px">
      <transition-group name="list-complete">
        <div v-for="(item, index) of neilingList" :key="item.id"
             style="background-color: white; margin: 0 4px 8px 4px; padding: 6px; overflow: hidden;"
             class="list-complete-item">
          <div @click="detail(item)">
            <div style="height: 26px; line-height: 28px;" :style="{'margin-top': index > 0 ? '6px' : 0}">
              <label class="label">单据编号</label>
              <span class="value">{{ item.code }}</span>
            </div>
            <div style="height: 26px; line-height: 28px; display: flex; align-items: center">
              <label class="label">商品名称</label>
              <span class="value">{{ item.goodsName }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">内领日期</label>
              <span class="value">{{ item.outDate }}</span>
            </div>
            <div style="height: 26px; line-height: 28px; display: flex; align-items: center">
              <label class="label">商品类型</label>
              <span class="value">{{ item.goodsType }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">内领数量</label>
              <span class="value">{{ item.goodsNum }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">单据状态</label>
              <span class="value">{{ convertStatus(item.status) }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品金额</label>
              <span class="value">{{ item.goodsPrice + ' 元' }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">仓库库位</label>
              <span class="value">{{ item.warehouseId | valueName('Warehouse') }}
            - {{ item.warehousePosId | valueName('WarehousePos') }}</span>
              <van-button v-if="deletable && item.status !== 2" plain hairline type="danger"
                          style="float: right; margin: 10px;" size="small"
                          @click.stop="deleteItem(item)">删除单据
              </van-button>
              <van-button v-if="canApprove && item.status === 1" plain hairline size="small"
                          style="float: right; margin: 10px;"
                          @click.stop="approve(item)">审批
              </van-button>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
    <van-popup v-model="filter.show" position="bottom" style="height: 230px" round safe-area-inset-bottom>
      <div style="text-align: center; margin-top: 20px; margin-bottom: 20px">筛选条件</div>
      <div class="filterDiv" style="display: flex; align-items: center">
        <label style="margin-right: 16px">选择仓库</label>
        <wx-warehouse-select v-model="filter.warehouse" select-all></wx-warehouse-select>
      </div>
      <div class="filterDiv" style="display: flex; align-items: center">
        <label style="margin-right: 16px">选择日期</label>
        <wx-date-select v-model="filter.begDate"></wx-date-select>
      </div>
      <div style="width: 100%; display: flex; justify-content: center; margin-top: 20px">
        <van-button style="width: 40%; height: 40px; font-size: 16px" size="small" @click="resetFilters">重置
        </van-button>
        <van-button style="width: 40%; height: 40px; font-size: 16px" size="small" type="primary"
                    @click="filter.show = false">完成
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Button, Popup, Search, Sticky, Tag, Field } from 'vant'
import WxWarehouseSelect from '@/views/wx/product/WxWarehouseSelect'
import WxDateSelect from '@/views/wx/product/WxDateSelect'
import authority from '@/utils/authority'

export default {
  name: 'WxNeiling',
  components: {
    WxDateSelect,
    WxWarehouseSelect,
    [Search.name]: Search,
    [Sticky.name]: Sticky,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Tag.name]: Tag,
    [Field.name]: Field
  },
  data () {
    return {
      loading: false,
      filter: {
        show: false,
        searchText: null,
        warehouse: null,
        begDate: null,
        endDate: null
      },
      field: {
        fieldValue: null,
        show: false
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$store.dispatch('neiling/all').finally(() => {
        this.loading = false
      })
    },
    onSearch () {
    },
    onMoreFilter () {
      this.filter.show = true
    },
    resetFilters () {
      this.filter.warehouse = null
      this.filter.begDate = null
    },
    add () {
      this.$router.push({
        path: '/wx_neiling_goods'
      })
    },
    detail (item) {
      this.$router.push({
        path: '/wx_neiling_goods',
        query: { neilingId: item.id }
      })
    },
    approve (item) {
      this.$confirm(`确认审核通过【${item.code}】, 是否继续?`, '提示', {
        confirmButtonText: '通过',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        item.status = 2
        this.$store.dispatch('neiling/updateOne', item).then(() => {
          this.$message.success('审批通过!')
        })
      }).catch(() => {
      })
    },
    deleteItem (item) {
      this.$confirm(`确认删除内领【${item.code}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('neiling/delete', item.id).then(() => {
          this.$message.success('删除成功!')
        })
      }).catch(() => {
      })
    },
    convertStatus (status) {
      switch (status) {
        case 0:
          return '已保存'
        case 1:
          return '未审批'
        case 2:
          return '审批通过'
      }
      return status
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  computed: {
    neilingList () {
      let list = this.$store.state.neiling.neilingList

      if (this.filter.searchText) {
        list = list.filter(neiling => {
          if (neiling.code && neiling.code.indexOf(this.filter.searchText) !== -1) return true
          for (const goods of neiling.goodsList) {
            if (goods.name && goods.name.indexOf(this.filter.searchText) !== -1) return true
          }
          return false
        })
      }

      if (this.filter.warehouse) {
        list = list.filter(neiling => {
          return neiling.warehouseId === this.filter.warehouse[0] && neiling.warehousePosId === this.filter.warehouse[1]
        })
      }

      if (this.filter.begDate !== null) {
        list = list.filter(neiling => {
          return this.filter.begDate.format('yyyy-MM-dd') === neiling.outDate
        })
      }

      return list
    },
    readOnly () {
      return !this.$hasPermission(authority.NEILING)
    },
    addable () {
      return this.$hasPermission(authority.NEILING)
    },
    deletable () {
      return this.$hasPermission(authority.NEILING)
    },
    canApprove () {
      return this.$hasPermission(authority.NEILING_SHENHE)
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  color: #606266;
  font-size: 14px;
}

.label {
  display: inline-block;
  width: 100px;
  color: #646464;
  font-size: 14px;
  text-align: right;
  height: 28px;
  line-height: 28px;
}

.value {
  display: inline-block;
  color: black;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
  margin-left: 20px;
}

.filterDiv {
  margin: 16px 30px;
  font-size: 16px;
  height: 22px;
  line-height: 22px;
  display: flex
}
</style>
